import * as React from "react"
const MagicWand2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      fillRule="evenodd"
      d="M9 1a1 1 0 1 0-2 0v.5a1 1 0 0 0 2 0V1ZM3.707 2.293a1 1 0 0 0-1.414 1.414l1 1a1 1 0 0 0 1.414-1.414l-1-1Zm10 1.414a1 1 0 0 0-1.414-1.414l-1 1a1 1 0 0 0 1.414 1.414l1-1ZM1 7a1 1 0 0 0 0 2h.5a1 1 0 0 0 0-2H1Zm14 0a1 1 0 1 0 0 2h.5a1 1 0 1 0 0-2H15ZM4.707 12.707a1 1 0 1 0-1.414-1.414l-1 1a1 1 0 1 0 1.414 1.414l1-1ZM9 15a1 1 0 1 0-2 0v.5a1 1 0 1 0 2 0V15Zm.414-10a2 2 0 0 0-2.828 0L5 6.586a2 2 0 0 0 0 2.828l2.293 2.293L18.586 23a2 2 0 0 0 2.828 0L23 21.414a2 2 0 0 0 0-2.828L11.707 7.293 9.414 5Zm-3 3L8 6.414 9.586 8 8 9.586 6.414 8Zm3 3L11 9.414 21.586 20 20 21.586 9.414 11Z"
      clipRule="evenodd"
    />
  </svg>
)
export default MagicWand2
